<template>
  <div class="user-info" @click="login_out">
    <img class="avatar" :src="userInfo.avatar" alt="" v-show="avatar">
    <div class="nickname"  v-show="nickname">{{userInfo.nickname}}</div>
  </div>
</template>

<script>
  import click_handler from '../../tools/mgtv/click'
  import {login, logout} from '../../tools/mgtv/login'
  import {mapState, mapActions} from 'vuex'
  export default {
    name: 'UserInfo',
    props: ['nickname','avatar'],
    data () {
      return {}
    },
    mounted(){
      
    },
    computed: {
        ...mapState([
            'actInfo',
            'userInfo',
            'deviceInfo',
            'ticket',
            'urlParams'
        ]),
      // user(){
      //   return window.$bus.user
      // }
    },
    methods: {
      ...mapActions(['requestLogin']),
      login_out(){
        //登录登出
        if (!this.userInfo.uuid) {
          click_handler('登录', ()=>{
            console.log("this.requestLogin")
            this.requestLogin()
          },{},
            this);
        } else {
          if (window.gact.is_h5) {
            click_handler('头像', () => {
                this.$dialog.confirm({
                  message: '您已登录，是否退出切换账号?'
                }).then(logout).catch(() => {
                  console.log('取消')
                });
              
              },
              {},
                this);
          }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  @import "../../share/mixins.styl"

  .user-info
    display inline-block
    position relative
    width: 1rem;
    cursor pointer

  .nickname
    width: 1rem;
    padding: 0.01rem 0.06rem
    line-height: .4rem;
    font-size: .16rem;
    background-color: #222676;
    border-radius: .4rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #ffffff;
    // border: 2px solid light-gray-color;
    text-align: center;
    margin-top: -0.2rem
    z-index 200
    position relative

  .avatar
    background-color: gray-color;
    width: 1.03rem;
    height:1.03rem;
    border-radius: 100%;
    border: 2px solid #ffffff;
    display block
    margin 0 auto

</style>



// WEBPACK FOOTER //
// src/components/common/UserInfo.vue